import PortfolioManagement from './Index.vue';

export const routes = [
  {
    path: 'gestao-carteira',
    name: 'talkvia_portfolio_management',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: PortfolioManagement,
  },
];
